import { useDispatch } from 'react-redux'
import { useTheme } from 'styled-components'

import { Card as CardV2, CardHeaderV2, Table, TableActionsWrapper, TableActionButton } from '@baseV2'
import { DRAWER_TYPES, strings } from '@constants'
import { toggleDrawer } from '@data/state/action/root'
import { DeleteOutline, EditOutlined, LocalAtmOutlined } from '@material-ui/icons'
import { capitalizeWord } from '@utils'

// Payment Terms card — same design as the Other Charges card (CardHeaderV2 link action + Table).
// Opens the shared EDIT_PAYMENT_TERMS drawer to add/edit the payment terms.
const PaymentTermsCard = ({ state, valueChangeHandler }) => {
	const globalDispatch = useDispatch()
	const theme = useTheme()
	const paymentTermsList = state?.newSpo?.payment_terms_list ?? []

	const callbackFunction = (_list) => {
		valueChangeHandler('payment_terms_list')(_list)
		globalDispatch(toggleDrawer(false))
	}

	const editPaymentTerms = () => {
		globalDispatch(
			toggleDrawer(true, DRAWER_TYPES.EDIT_PAYMENT_TERMS, {
				label: strings('payment_terms'),
				callbackFunction,
				data: state?.newSpo?.payment_terms_list,
				isSupplier: true,
			})
		)
	}

	const columns = [
		{ label: 'Payment Method', key: 'payment_term', renderer: (val) => capitalizeWord(val || ''), sortable: false },
		{ label: 'Tenure in Days', key: 'tenure_in_days', sortable: false },
		{ label: 'Percentage(%)', key: 'percentage', sortable: false },
		{
			label: 'Condition',
			key: 'condition',
			renderer: (val) => (val ? val.split('_').map((word) => capitalizeWord(word)).join(' ') : ''),
			sortable: false,
		},
		{
			label: 'Actions',
			align: 'right',
			sortable: false,
			renderer: () => (
				<TableActionsWrapper>
					<TableActionButton color={theme.colors.status.error.text} onClick={editPaymentTerms}>
						<DeleteOutline />
					</TableActionButton>
					<TableActionButton color={theme.colors.brand.primary} onClick={editPaymentTerms}>
						<EditOutlined />
					</TableActionButton>
				</TableActionsWrapper>
			),
		},
	]

	return (
		<CardV2 hoverable={false}>
			<CardHeaderV2
				title={strings('payment_terms')}
				icon={LocalAtmOutlined}
				showAction
				actionLabel={paymentTermsList.length > 0 ? strings('edit') : strings('add')}
				onAction={editPaymentTerms}
			/>
			<Table columns={columns} data={paymentTermsList} hideFooter />
		</CardV2>
	)
}

export default PaymentTermsCard
